/**
 * This creates an asynchronous boundary and splits out initilization code.
 * @seemore - https://webpack.js.org/concepts/module-federation/#troubleshooting
 */
import('./bootstrap');
export {};
